export type ApplicationStartupStatus = 'loading' | 'ready' | 'failed';
export type StartupSceneStatus = 'initializing' | 'ready' | 'recovering' | 'failed';

/** Coordinates the first complete screen; subsequent data refreshes stay local. */
export const createApplicationStartup = () => {
  let enabled = false;
  let revealed = false;
  let mounted = false;
  let failed = false;
  let scene: StartupSceneStatus = 'initializing';
  const pending = new Set<symbol>();
  const listeners = new Set<() => void>();
  const emit = () => listeners.forEach(listener => listener());
  const getStatus = (): ApplicationStartupStatus => {
    if (!enabled) return 'ready';
    if (failed || scene === 'failed') return 'failed';
    return mounted && scene === 'ready' && pending.size === 0 ? 'ready' : 'loading';
  };
  return {
    getStatus,
    start: () => { enabled = true; emit(); },
    fail: () => { failed = true; emit(); },
    markMounted: () => { mounted = true; emit(); },
    markRevealed: () => { revealed = true; },
    setSceneStatus: (status: StartupSceneStatus) => { scene = status; emit(); },
    begin: () => {
      if (!enabled || revealed) return () => {};
      const token = Symbol('startup-task');
      pending.add(token);
      emit();
      return () => { if (pending.delete(token)) emit(); };
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => { listeners.delete(listener); };
    },
  };
};

// Only index.web.js enables this coordinator. Native startup stays unchanged.
export const applicationStartup = createApplicationStartup();
